import ReactGA from 'react-ga';
import { APP_VERSION, TRACKING_ID } from '../constants';
import { TrackingEventData, TrackingExceptionData } from '../interfaces';

export const initializeTracking = () => {
  ReactGA.initialize(TRACKING_ID, {
    gaOptions: {
      siteSpeedSampleRate: 100
    },
  });
  ReactGA.set({ appName: 'tone-transfer' });
  ReactGA.set({ appVersion: APP_VERSION });
  ReactGA.set({ anonymizeIp: true });
  // Scrub parameters from referrer URL
  ReactGA.set({ referrer: document.referrer.split('?')[0] });
  ReactGA.pageview('/');
};

export const trackEvent = (eventData: TrackingEventData) => {
  ReactGA.event(eventData);
};

export const trackException = (exceptionData: TrackingExceptionData) => {
  ReactGA.exception(exceptionData);
};
